// Reine Formatierungs-/Rechen-Helfer für das Preis-Management-UI. Seiteneffektfrei.

/** Formatiert eine Zahl als Euro (de-DE). Null/undefined/leer -> "—". */
export function fmtEUR(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === '') return '—'
  const num = typeof n === 'number' ? n : Number(n)
  if (Number.isNaN(num)) return '—'
  return num.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
}

/** Rechnet einen Marge-Bruch (0.2) in eine Prozent-Anzeige ("20 %"). */
export function fmtPct(fraction: number | null | undefined): string {
  if (fraction === null || fraction === undefined || Number.isNaN(fraction)) return '—'
  const pct = fraction * 100
  return `${pct.toLocaleString('de-DE', { maximumFractionDigits: 2 })} %`
}

export interface PriceDelta {
  abs: number
  pct: number | null
  dir: 'up' | 'down' | 'flat'
}

/** Differenz zwischen aktuellem VK und Entwurf. pct = null wenn currentVk 0. */
export function priceDelta(currentVk: number, draft: number): PriceDelta {
  const abs = Math.round((draft - currentVk) * 100) / 100
  const dir: PriceDelta['dir'] = abs > 0 ? 'up' : abs < 0 ? 'down' : 'flat'
  const pct = currentVk === 0 ? null : Math.round((abs / currentVk) * 10000) / 100
  return { abs, pct, dir }
}
